import React, {useContext} from 'react'
import { Link } from 'react-router-dom'
import crumbContext from "contexts/crumbs"
import headbandContext from "contexts/headband"
export default function Links(props) {
    const {text, picto, url, color} = props
	const {crumbs, setCrumbs} = useContext(crumbContext)
    const {setHeadband} = useContext(headbandContext)
	const addCrumb = {
        title : text,
        icon : picto,
        page : url,
        color : color
    }
    return (       
        <Link 
            to={url} 
            className='flex between links'
            onClick={() => {
				setCrumbs(oldCrumbs => [...oldCrumbs, addCrumb])
				setHeadband({
					title : text,
					icon : picto,
					color : color
				})
				
			}} 
        >
            <div className="centerImg darkBlue" style={{backgroundColor : picto === "icone_CHU_Rouen_vert.svg" && "transparent"}}>
                <img src={`/${picto}`} alt="picto" />
            </div>
            <div style={{width : "75%"}}>
                <p>
                    {text}   
                </p>
            </div>
        </Link>

    )
}
